"use client";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  location: {},
  draggedLocation: {},
};

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setIsOpen(state, action) {
      state.isOpen = action.payload;
    },

    setInitialMapLocation(state, action) {
      state.location = action.payload;
    },
    setDraggedMapLocation(state, action) {
      state.draggedLocation = action.payload;
    },
    resetMapState() {
      return initialState;
    },
  },
});

export const {
  setIsOpen,
  setInitialMapLocation,
  setDraggedMapLocation,
  resetMapState,
} = mapSlice.actions;

export default mapSlice.reducer;
